export function getAll() {
  return [
    {
      value: 2,
      name: "Unpurchased",
      text: "待採購",
    },
    {
      value: 3,
      name: "Purchasing",
      text: "採購中",
    },
    {
      value: 4,
      name: "Purchased",
      text: "採購完成",
    },
  ];
}

export function getByValue(value) {
  const statusTypes = [
    { value: 0, name: "Create", text: "建立中" },
    { value: 1, name: "Done", text: "完成" },
    ...getAll(),
    { value: 5, name: "PendingSignoff", text: "待簽核" },
  ];
  return statusTypes.find((item) => item.value === Number(value));
}
